export const SellerBenefits = () => {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Cash Offers',
      description: 'We provide all-cash offers with no financing contingencies, ensuring a smooth and certain closing.'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Quick Closings',
      description: 'Close in 30-45 days on your schedule. We work around your timeline and needs.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Buy As-Is',
      description: 'No need for repairs, renovations, or capital improvements. We buy properties in any condition.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Simple Process',
      description: 'Minimal paperwork and hassle. We handle the complexity so you don\'t have to.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Confidential Sale',
      description: 'Discreet transactions that protect your privacy and maintain tenant relationships.'
    },
    {
      icon: 'ri-percent-line',
      title: 'No Commissions',
      description: 'Direct buyer means no broker commissions—you keep more of the sale proceeds.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Benefits of Selling to Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            When you sell your mid-rise apartment building to us, you gain advantages that traditional sales simply can't match.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-8 hover:shadow-lg transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 text-white rounded-xl mb-6">
                <i className={`${benefit.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-900">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-8 text-center text-gray-900">Compare Your Options</h3>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-teal-500">
                  <th className="text-left py-4 px-4 text-gray-900 font-semibold">Feature</th>
                  <th className="text-center py-4 px-4 text-teal-600 font-semibold">Selling to Us</th>
                  <th className="text-center py-4 px-4 text-gray-600 font-semibold">Traditional Sale</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-4 font-medium">Timeline to Close</td>
                  <td className="text-center py-4 px-4">
                    <span className="inline-block bg-teal-500 text-white px-3 py-1 rounded-full text-sm font-semibold">30-45 days</span>
                  </td>
                  <td className="text-center py-4 px-4 text-gray-500">90-180 days</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-4 font-medium">Repairs Needed</td>
                  <td className="text-center py-4 px-4">
                    <i className="ri-close-circle-fill text-teal-500 text-2xl"></i>
                  </td>
                  <td className="text-center py-4 px-4">
                    <i className="ri-check-fill text-gray-400 text-2xl"></i>
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-4 font-medium">Broker Commissions</td>
                  <td className="text-center py-4 px-4">
                    <span className="inline-block bg-teal-500 text-white px-3 py-1 rounded-full text-sm font-semibold">$0</span>
                  </td>
                  <td className="text-center py-4 px-4 text-gray-500">3-6% of sale price</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-4 font-medium">Financing Contingency</td>
                  <td className="text-center py-4 px-4">
                    <i className="ri-close-circle-fill text-teal-500 text-2xl"></i>
                  </td>
                  <td className="text-center py-4 px-4">
                    <i className="ri-check-fill text-gray-400 text-2xl"></i>
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-4 font-medium">Showings Required</td>
                  <td className="text-center py-4 px-4">
                    <span className="inline-block bg-teal-500 text-white px-3 py-1 rounded-full text-sm font-semibold">1 visit</span>
                  </td>
                  <td className="text-center py-4 px-4 text-gray-500">Multiple showings</td>
                </tr>
                <tr>
                  <td className="py-4 px-4 font-medium">Deal Certainty</td>
                  <td className="text-center py-4 px-4">
                    <span className="inline-block bg-teal-500 text-white px-3 py-1 rounded-full text-sm font-semibold">Guaranteed</span>
                  </td>
                  <td className="text-center py-4 px-4 text-gray-500">Uncertain</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};